export const pageSize = 10;
export const dateColWidth = 250;
export const typeColWidth = 170;
export const fixedColWidth = 130;
